import Alpine from "alpinejs";

Alpine.data('carouselPagination', (id) => {
  return {
    id: id,
    visibleItems: [],
    get carousel() {
      return document.querySelector(`[x-data="carousel('${this.id}')"]`)
    },
    init() {
      window.addEventListener(`carousel:${this.id}:item-enter`, (event) => {
        const index = event.detail.index;
        if (!this.visibleItems.includes(index)) {
          this.visibleItems.push(index);
          this.visibleItems.sort((a, b) => a - b);
        }
      });

      window.addEventListener(`carousel:${this.id}:item-leave`, (event) => {
        const index = event.detail.index;
        this.visibleItems = this.visibleItems.filter((i) => i !== index);
      });
    }
  };
});